import { useContext } from 'react';
import { RateCardStoreContext } from './store-context';

const useRateCardStore = () => useContext(RateCardStoreContext);

export default useRateCardStore;
